import { authConstants } from "../actions/constants";

export default function authReducer(
  state = {
    token: null,
    admin: null,
    authenticating: false,
    authenticate: false,
    error: null,
  },
  action,
) {
  switch (action.type) {
    case authConstants.ADMIN_LOGIN_REQUEST:
      return {
        ...state,
        authenticating: true,
        authenticate: false,
        error: null,
      };
    case authConstants.ADMIN_LOGIN_SUCCESS:
      return {
        ...state,
        authenticating: false,
        authenticate: true,
        token: action.payload.token,
        admin: action.payload.admin,
        error: null,
      };
    case authConstants.ADMIN_LOGIN_FAILURE:
      return {
        ...state,
        authenticating: false,
        authenticate: false,
        error: action.payload.error,
      };
    case authConstants.ADMIN_LOGOUT_REQUEST:
      return {
        ...state,
        error: null,
      };
    case authConstants.ADMIN_LOGOUT_SUCCESS:
      return {
        ...state,
        token: null,
        admin: null,
        authenticating: false,
        authenticate: false,
        error: null,
      };
    case authConstants.ADMIN_LOGOUT_FAILURE:
      return {
        ...state,
        authenticating: false,
        error: action.payload.error,
      };
    case authConstants.GET_ADMIN_REQUEST:
      return {
        ...state,
        error: null,
      };
    case authConstants.GET_ADMIN_SUCCESS:
      return {
        ...state,
        admin: action.payload.admin,
        error: null,
      };
    case authConstants.GET_ADMIN_FAILURE:
      return {
        ...state,
        error: action.payload.error,
      };
    default:
      return state;
  }
}
